// PGCET MCA Mock 8 — Analytical Ability & Logical Reasoning (questions 56–70)
const pgcetmcaAnalyticalReasoning = [
  {
    id: 56,
    question: "In a class of 45 students, Kavitha ranks 12th from the top. What is her rank from the bottom?",
    options: ["A. 33", "B. 35", "C. 32", "D. 34"],
    answer: "D"
  },
  {
    id: 57,
    question: "In a queue, Pooja is 7th from the front and Harish is 11th from the back. Pooja is ahead of Harish and there are exactly 4 people between them. How many people are there in the queue?",
    options: ["A. 22", "B. 21", "C. 23", "D. 20"],
    answer: "A"
  },
  {
    id: 58,
    question: "Among five friends P, Q, R, S and T, P is heavier than Q but lighter than R. S is heavier than R, and T is the lightest of all. Who is the third heaviest?",
    options: ["A. R", "B. Q", "C. P", "D. S"],
    answer: "C"
  },
  {
    id: 59,
    question: "Sunil ranked 8th from the top and 28th from the bottom among the students who passed an examination. If 6 students failed the examination, how many students appeared for it?",
    options: ["A. 40", "B. 36", "C. 42", "D. 41"],
    answer: "D"
  },
  {
    id: 60,
    question: `An input–output machine rearranges numbers step by step as shown:
      Input: 48 13 72 29 56
      Step I: 13 48 72 29 56
      Step II: 13 29 48 72 56
      Step III: 13 29 48 56 72
      Following the same rule, what will be Step II for the input 67 21 89 35 12?`,
    options: ["A. 12 67 21 89 35", "B. 12 21 35 67 89", "C. 12 21 67 89 35", "D. 21 12 67 89 35"],
    answer: "C"
  },
  {
    id: 61,
    question: `A word-arrangement machine works as follows:
      Input: tree apple sun ball king
      Step I: apple tree sun ball king
      Step II: apple ball tree sun king
      Step III: apple ball king tree sun
      Step IV: apple ball king sun tree
      Following the same rule, how many steps are needed to complete the arrangement for the input: mango cat yes dog rat?`,
    options: ["A. 2", "B. 4", "C. 5", "D. 3"],
    answer: "D"
  },
  {
    id: 62,
    question: "Which of the following Venn diagram descriptions best represents the relationship among Women, Mothers and Doctors?",
    options: [
      "A. The circle for Mothers lies entirely inside the circle for Women, and the circle for Doctors partly overlaps both",
      "B. Three mutually intersecting circles, none lying inside another",
      "C. The circle for Women lies entirely inside the circle for Mothers, and Doctors is a separate circle",
      "D. Three separate circles with no overlap"
    ],
    answer: "A"
  },
  {
    id: 63,
    question: "In a sports club, 25 members play only cricket, 20 play only football, 15 play only hockey, 8 play cricket and football but not hockey, 6 play football and hockey but not cricket, 5 play cricket and hockey but not football, and 3 play all three games. How many members play football?",
    options: ["A. 37", "B. 34", "C. 31", "D. 29"],
    answer: "A"
  },
  {
    id: 64,
    question: "Find the odd one out: 17, 29, 41, 51, 59",
    options: ["A. 29", "B. 51", "C. 41", "D. 59"],
    answer: "B"
  },
  {
    id: 65,
    question: "Find the odd one out: Keyboard, Mouse, Scanner, Printer",
    options: ["A. Keyboard", "B. Mouse", "C. Scanner", "D. Printer"],
    answer: "D"
  },
  {
    id: 66,
    question: "A cuboid measuring 4 cm × 3 cm × 2 cm is painted on all its faces and then cut into 1 cm cubes. How many of the small cubes have exactly two faces painted?",
    options: ["A. 8", "B. 12", "C. 16", "D. 10"],
    answer: "B"
  },
  {
    id: 67,
    question: "Two different views of the same die are seen. In the first view the visible faces show 1, 2 and 3; in the second view the visible faces show 1, 4 and 5. Which number is on the face opposite 6?",
    options: ["A. 2", "B. 3", "C. 1", "D. 4"],
    answer: "C"
  },
  {
    id: 68,
    question: `What is the value of the positive integer x?
      Statement I: x² = 49.
      Statement II: x is a prime number less than 10.`,
    options: [
      "A. Statement I alone is sufficient",
      "B. Statement II alone is sufficient",
      "C. Both statements together are needed",
      "D. Both statements together are not sufficient"
    ],
    answer: "A"
  },
  {
    id: 69,
    question: `What is Rohit's rank from the top in his class of 40 students?
      Statement I: Rohit is 15 ranks below Suma.
      Statement II: Suma is 6th from the top.`,
    options: [
      "A. Statement I alone is sufficient",
      "B. Statement II alone is sufficient",
      "C. Both statements together are needed",
      "D. Both statements together are not sufficient"
    ],
    answer: "C"
  },
  {
    id: 70,
    question: `What is the area of rectangle ABCD?
      Statement I: Its perimeter is 28 cm.
      Statement II: Its length is 8 cm and its diagonal is 10 cm.`,
    options: [
      "A. Statement I alone is sufficient",
      "B. Statement II alone is sufficient",
      "C. Both statements together are needed",
      "D. Both statements together are not sufficient"
    ],
    answer: "B"
  }
];

export default pgcetmcaAnalyticalReasoning;
